import { render, staticRenderFns } from "./collectAgreementManage.vue?vue&type=template&id=bd8f64de&scoped=true"
import script from "./collectAgreementManage.vue?vue&type=script&lang=js"
export * from "./collectAgreementManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8f64de",
  null
  
)

export default component.exports